<template>
  <Modal v-model="show" :mask-closable="false"  @on-ok="save" :loading="loading">
    <div slot="header" class="modal-header">修改信息</div>
    <Form :model="formData" :label-width="85"  :rules="formRules" ref="formData">
      <FormItem label="项目名称：" prop="projectFid">
        <Select v-model="formData.projectFid" class="item-width" placeholder="请选择项目" :disabled="true">
          <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </FormItem>
      <FormItem label="电话：" prop="pzoPhone">
        <Input v-model="formData.pzoPhone" class="item-width" ></Input>
      </FormItem>
      <FormItem label="" style="margin-top: -15px;" class="linh1">
        <Checkbox  v-model="formData.isBeijing" class="error-color">非北京归属地，请勾选</Checkbox>
      </FormItem>
      <FormItem label="系统号：" prop="pzoEmpCode" hidden>
        <Input v-model="formData.pzoEmpCode" class="item-width" :disabled="true" ></Input>
      </FormItem>
      <FormItem label="员工姓名：" prop="pzoName">
        <Input v-model="formData.pzoName" :disabled="true" class="item-width" ></Input>
      </FormItem>
      <FormItem label="所属部门：" prop="pzoDepartment">
        <Input :disabled="true" v-model="formData.pzoDepartment" class="item-width" ></Input>
      </FormItem>
      <FormItem label="员工类型：" prop="empType">
        <Select v-model="formData.empType" class="item-width" placeholder="请选择项目" @on-change="changEmpType">
          <Option v-for="item in empTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </FormItem>
      <FormItem label="" prop="isProjectManager" v-if="formData.empType==1">
        <Checkbox  v-model="formData.isProjectManager">项目经理</Checkbox>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="handleCancel">取消</Button>
      <Button type="primary" size="large" @click="save" :loading="loading">
        <span v-if="!loading">保存</span>
        <span v-else>保存中...</span>
      </Button>
    </div>
  </Modal>
</template>
<script type="text/ecmascript-6">
import { getEHRUseInfo,modifyZO } from 'api/managementCenter'

export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    projectList:{
      type:Array,
      default(){
        return []
      }
    },
    empTypeList:{
      type:Array,
      default(){
        return []
      }
    },
    fid:{
      type:String,
      default:''
    },
    projectFid:{
      type:String,
      default:''
    },
    pzoName:{
      type:String,
      default:''
    },
    pzoPhone:{
      type:String,
      default:''
    },
    pzoDepartment:{
      type:String,
      default:''
    },
    pzoEmpCode:{
      type:String,
      default:''
    },
    empType:{
      type:Number,
      default:0
    },
    isProjectManager:{
      type:Number,
      default:0
    },
    isBeijing:{
      type:Boolean,
      default:false
    },
  },
  watch:{
    n(val){
      this.$refs['formData'].resetFields();
      // this.formData.isProjectManager = false
      this.formData.fid = this.fid
      this.formData.projectFid = this.projectFid
      this.formData.pzoName = this.pzoName
      this.formData.pzoPhone = this.pzoPhone
      this.formData.pzoDepartment = this.pzoDepartment
      this.formData.pzoEmpCode = this.pzoEmpCode
      this.formData.empType = this.empType
      this.formData.isProjectManager = this.isProjectManager ? true : false
      this.formData.isBeijing = this.isBeijing
      if(!this.pzoDepartment){
        this.getDepartment(this.pzoPhone)
      }
      this.show = true;
    }
  },
  data () {
    return {
      // isBeijing:false,

      show:false,
      loading:false,
      checkAll:false,
      products:[],
      formData:{
        fid:'',
        projectFid:'',
        pzoEmpCode:'',
        pzoName:'',
        pzoPhone:'',
        pzoDepartment:'',
        empType:'',
        isProjectManager:false,
        // isBeijing: false,
      },
      formRules:{
        projectFid:[{ required:true, type:'string', message:'请选择项目',triger:'blur' }],
        pzoEmpCode:[{ required:true, type:'string', message:'请输入系统号',triger:'blur' }],
        pzoName:[{ required:true, type:'string', message:'员工姓名为空',triger:'blur' }],
        pzoPhone:[{ required:true, type:'string', message:'员工手机号为空',triger:'blur' }],
        pzoDepartment:[{ required:true, type:'string', message:'所属部门为空',triger:'blur' }],
        empType:[{ required:true, type:'number', message:'请选择系员工类型', triger:'change' }],
      }
    };
  },

  methods:{
    changEmpType(val){
     if(val === 2){
       this.formData.isProjectManager = false
     }
   },
    handleCancel(){
      this.show = false
    },
    getDepartment(pzoEmpCode){
      getEHRUseInfo(pzoEmpCode).then( res => {
        if(res.data.name){
          this.formData.pzoDepartment = res.data.dept
        } else {
          this.$Message.info('该手机号不存在！')
        }
      })
    },
  save(){
    this.loading = true
    this.$refs[`formData`].validate(bool => {
      if(bool){
        let data = Object.assign({},this.formData)
        data.isProjectManager = data.isProjectManager ? 1 : 0
        modifyZO(data).then( res => {
          this.loading = false
          this.$Message.success('修改项目权限成功！')
          this.$emit('refresh')
          this.show = false
        }).catch( res => {
          this.loading = false
        })
      }else {
        this.loading = false
      }
    })
  }

 }
}
</script>
<style scoped>
.ivu-select-selection {
  line-height: 1.5;
  padding: 4px 7px;
}
.check-box {
  width:300px;
}
.ivu-checkbox-group-item{
  display: block;
}
.item {
  line-height: 1.5;
  padding: 4px 7px;

}
</style>

